// AuthErrorScreen.js
import React from 'react';
import './AuthErrorScreen.css';

// 依實際發生的原因分流顯示文案，避免所有未登入情境都套用同一句「無使用權限」
const REASON_CONTENT = {
  'network-check-failed': {
    title: '暫時無法確認您的網路環境',
    message: '系統目前無法確認您的連線來源，可能是暫時性問題。請稍後重新整理頁面再試；若持續發生，請聯絡系統管理員。',
    showRetry: true,
  },
  'mplus-failed': {
    title: 'M+ 連結已失效',
    message: '透過 M+ 進入時發生問題，可能是連結已逾時或驗證失敗。請返回 M+ 重新點擊進入本系統；若持續發生，請聯絡系統管理員。',
    showRetry: false,
  },
  'sso-failed': {
    title: '企業單一登入失敗',
    message: '系統無法完成您的企業帳號驗證，可能是登入連結已逾時。請重新由入口網站發起登入；若持續發生，請聯絡系統管理員。',
    showRetry: false,
  },
  'session-expired': {
    title: '登入已逾時',
    message: '您的登入狀態已逾時。若您位於公司內部網路，請重新整理頁面登入；若位於外部網路，請改由 M+ 重新進入本系統。',
    showRetry: true,
  },
  external: {
    title: '目前的網路環境無法使用本系統',
    message: '本系統僅開放公司內部網路使用，如需在外部網路使用，請透過 M+ 進入。如認為此訊息有誤，請聯絡系統管理員協助確認。',
    showRetry: false,
  },
};

function AuthErrorScreen({ reason }) {
  const content = REASON_CONTENT[reason] || REASON_CONTENT.external;

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="auth-error-screen">
      <div className="auth-error-card">
        <div className="auth-error-icon" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a1.5 1.5 0 0 0 1.3 2.25h17.76a1.5 1.5 0 0 0 1.3-2.25L13.71 3.86a1.5 1.5 0 0 0-2.42 0Z"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="auth-error-title">{content.title}</div>
        <div className="auth-error-message">{content.message}</div>
        {content.showRetry && (
          <button type="button" className="auth-error-retry-btn" onClick={handleRetry}>
            重新整理
          </button>
        )}
      </div>
    </div>
  );
}

export default AuthErrorScreen;
